<div class="title">
  <div class="coldx ">
    <h4>{{roleSelected && roleSelected.id ? 'Modifica Ruolo' : 'Crea Ruolo'}}</h4>
  </div>
</div>

<form [formGroup]="form" (click)="errorCheck()">

  <div class="row">
    <div class="col-sm-6">
      <div class="form-group"> <label for="">Nome ruolo</label> <span _ngcontent-c10=""
          class="mandatory ">*</span>
        <input placeholder="Inserisci nome ruolo" [(ngModel)]="role.name" formControlName="name" id=""
          type="text" class="form-control">
      </div>
    </div>
    <div class="col-sm-6">
      <div class="form-group"> <label for="">Descrizione ruolo</label> <span _ngcontent-c10=""
          class="mandatory ">*</span>
        <input placeholder="Inserisci descrizione ruolo " [(ngModel)]="role.description"
          formControlName="description" id="" type="text" class="form-control">

      </div>
    </div>
  </div>




  <div class="form-row" *ngIf="formEdit">
    <div class="col-sm-6 col-sm-offset-6">
      <div class="form-check">
        <label for="" class="form-check-label">Abilitata</label>
        <span _ngcontent-c10="" class="mandatory">*</span>
        <input formControlName="enabled" id="" type="checkbox" class="form-check-input" style="margin-left: 10px">
      </div>
    </div>
  </div>

  <p class="col-md-12 mandatory"><em>* Campi obbligatori</em></p>
  <div class="form-row">
    <div class="col-xs-12 col-sm-6"></div>

    <div class="col-xs-6 col-sm-3 "> <button type="button" class="btn btn-outline-secondary btn-block" (click)="formReset()">Reset</button>
    </div>
    <div *ngIf="!formEdit" class="col-xs-6 col-sm-3 "> <button type="submit" (click)="onSave()" [disabled]="!form.valid"
        class="btn btn-primary btn-block   ">{{roleSelected && roleSelected.id  ? 'Salva' : 'Crea'}}</button> </div>
  </div>

</form>
